import { render, staticRenderFns } from "./chat-list-item.vue?vue&type=template&id=50a1ff50&scoped=true"
import script from "./chat-list-item.vue?vue&type=script&lang=ts"
export * from "./chat-list-item.vue?vue&type=script&lang=ts"
import style0 from "./chat-list-item.vue?vue&type=style&index=0&id=50a1ff50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1ff50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
